import { render } from "./ForbiddenPage.vue?vue&type=template&id=232bae2a&scoped=true"
const script = {}

import "./ForbiddenPage.vue?vue&type=style&index=0&id=232bae2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232bae2a"]])

export default __exports__